import React, { FC } from 'react'
import { HStack } from '@chakra-ui/react'
import { Rw1LogoColored } from '@rw1/shared-lib'

export const Header: FC = () => (
  <HStack justifyContent="center" marginBottom={-4} paddingTop={4}>
    <Rw1LogoColored height="3rem" justifySelf="center" width="11rem" />
  </HStack>
)
